export enum Sort {
  PriceAsc = 'Low to High',
  PriceDesc = 'High to Low',
  // DateAsc = 'Newest',
  // DateDesc = 'Oldest first',
  Default = 'Featured',
  // AlphaAsc = 'A - Z',
  // AlphaDesc = 'Z - A',
}
